(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.dashboard-card-marketplace-footer', [
    'pp.widgets-templates',
    'pp.filters.numbers'
]);

ngModule.component('ppDashboardCardMarketplaceFooter', {
    templateUrl: 'widgets/_angular/dashboard-card-marketplace-footer/dashboard-card-marketplace-footer.tpl.html',
    bindings: {
        property: '<'
    },
    controllerAs: 'vm',
    controller: ['$scope', function ($scope) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);